module.exports = "3dae31887000464f6d7d01fe2c1d540c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/flags/japan.png
// module id = 102
// module chunks = 0